import { useState, useEffect } from 'react';

// Плавний лічильник від 0 до target (cubic easeOut). Використовується
// на сторінці входу (загальна кількість записів фонду) і в StatsPage (метрики).
export default function AnimatedCounter({ target, duration = 1200 }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!target && target !== 0) return;
    let raf;
    const start = Date.now();
    const tick = () => {
      const elapsed  = Date.now() - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased    = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(eased * target));
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);
  return <span>{count.toLocaleString('uk-UA')}</span>;
}
